import {API} from "@/Composables/api";

const getGroupQuestions = async (group, params = {}) => {
    return API.get(route("groups.questions.index", [group]), params);
};

const getGroupQuestion = async (group, question, params, toast) => {
    return API.get(route("groups.questions.show", [group, question]), params, toast);
};
const saveGroupQuestion = async (group: string, question: string, data = {}, params = {}) => {
    return API.post(route("groups.questions.store", {group, question}), params, data);
};
const saveGroupQuestions = async (group: string, data = {}, params = {}) => {
    return API.post(route("groups.questions.launch", {group}), params, data);
};
const syncGroupQuestions = async (group: string, questions, params = {}) => {
    return API.post(route("groups.questions.sync", group), params, {questions});
};

const deleteGroupQuestion = async (group: string, question: string, params = {}) => {
    return API.delete(route("groups.questions.destroy", {group, question}), params);
};

const updatePublishDates = async (group: string, question: string, data = {}) => {
    return API.put(route("groups.questions.update", {group, question}), {}, data);
};

const updateParams = async (group: string, question: string, data = {}) => {
    return API.put(route("groups.questions.update-params", {group, question}), {}, data);
};

const reorderGroupQuestion = async (group: string, question: string, data = {}) => {
    return API.put(route("groups.questions.reorder", {group, question}), {}, data);
};

const setGroupQuestionsOrder = async (group: string, data, params = {}) => {
    return API.put(route("groups.questions.set-order", {group}), params, data);
};

const togglePinGroupQuestion = async (group: string, question: string) => {
    return API.put(route("groups.questions.toggle-pin", {group, question}), {}, {});
};

const deleteMultipleGroupQuestions = async (group: string, data: {group_questions: string[]}) => {
    return API.post(route("groups.questions.destroy-multiple", {group}), {}, data, "delete");
};

const updateMultipleGroupQuestions = async (group: string, data: object) => {
    return API.put(route("groups.questions.update-multiple", {group}), {}, data);
};

const tagMultipleGroupQuestions = async (
    group: string,
    data: {group_questions: string[]; tags: string[]; mode: "replace" | "add"},
) => {
    return API.put(route("groups.questions.tag-multiple", {group}), {}, data);
};

export {
    syncGroupQuestions,
    deleteGroupQuestion,
    deleteMultipleGroupQuestions,
    saveGroupQuestion,
    getGroupQuestion,
    getGroupQuestions,
    saveGroupQuestions,
    updatePublishDates,
    updateMultipleGroupQuestions,
    tagMultipleGroupQuestions,
    updateParams,
    reorderGroupQuestion,
    setGroupQuestionsOrder,
    togglePinGroupQuestion,
};
